/**
 * Support for dd/mm/yyyy format.
 * 31/07/2018 or 31/7/2018 is allowed.
 */
import { addLeadingZero, isDate } from "../DateUtils";
export default {
  placeholder: () => "dd/mm/yyyy",
  convertToDate: value => {
    const parsedDateValues = value.split("/");
    const year = parsedDateValues[2];
    const month = parsedDateValues[1] - 1;
    const day = parsedDateValues[0];
    return new Date(year, month, day);
  },
  convertToString: date => {
    if (isDate(date)) {
      const month = addLeadingZero(date.getMonth() + 1);
      const day = addLeadingZero(date.getDate());
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    }

    return "";
  },
  customValidator: value => {
    const dateRegex = /^\d{1,2}\/\d{1,2}\/\d{4}$/g;
    return dateRegex.test(value);
  },
  extractDayMonthYear: value => {
    const dateParts = value.split("/");
    return {
      day: Number(dateParts[0]),
      month: Number(dateParts[1]) - 1,
      year: Number(dateParts[2])
    };
  }
};